<template>
<div>
    <vue-headful :title="(catalog.id ? 'Edit' : 'New') + 'Catalog [Safety Data Sheets] :: MeritEHS'" />

    <h4 class="py-3 mb-4">
        <ol class="breadcrumb font-weight-bold m-0">
            <li class="breadcrumb-item font-weight-light">
                <router-link :to="`/safety-data-sheets`">
                    <i class="fa fa-files-o"></i> Safety Data Sheets
                </router-link>
            </li>
            <li class="breadcrumb-item font-weight-light">
                <router-link :to="`/safety-data-sheets#catalogs`">
                    Catalogs
                </router-link>
            </li>
            <template v-if="catalog.id">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/safety-data-sheets/catalogs/view/${catalog.id}`">
                        {{ catalog.catalog_name }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Edit
                </li>
            </template>
            <li class="breadcrumb-item active" v-else>
                New
            </li>
        </ol>
    </h4>
    <template v-if="!loading">
        <i class="fa fa-circle-o-notch fa-spin"></i> Loading
    </template>
    <template v-else>
        <div class="row">
            <div class="col-md-6">
                <div class="card mb-2">
                    <div class="card-header">
                        Catalog
                    </div>
                    <div class="card-body">
                        <div class="row form-group">
                            <label class="col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.catalog_name}">Catalog Name:</label>
                            <div class="col-md-6 col-sm-8">
                                <input type="text" name="catalog_name" v-model="catalog.catalog_name" :class="{'form-control': true, 'is-invalid': errors.catalog_name}" placeholder="Enter Catalog Name" />
                                <span v-if="errors.catalog_name" class="text-danger">
                                    <span v-for="error in errors.catalog_name">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-3 mb-4">
            <div class="card-header">
                Data Sheets ({{ sheets.length }})
            </div>
            <div class="card-body">
                <div class="row mb-4">
                    <div class="col-md-3 text-md-right">Add Data Sheets:</div>
                    <div class="col-md-6">
                        <safety-data-sheets-select ref="newSheetSelect" @vselected="addSheet"></safety-data-sheets-select>
                    </div>
                </div>

                <b-table bordered striped hover :items="sheets" :fields="columns">
                    <template v-slot:cell(id)="data">
                        <button type="button" v-on:click="removeSheet(data.item.id)" class="btn btn-sm btn-default" title="Remove Data Sheet from this Catalog"><i class="fa fa-trash text-danger"></i></button>
                    </template>
                    <template v-slot:cell(data_sheet_name)="data">
                        <router-link :to="`/safety-data-sheets/view/${data.item.id}`">{{ data.item.data_sheet_name }}</router-link>
                    </template>
                </b-table>
            </div>
        </div>

        <button class="btn btn-success mr-3" @click="saveCatalog" :disabled="saving">
            <template v-if="!saving">Save</template>
            <template v-else>
                Saving <i class="fa fa-spin fa-circle-o-notch"></i>
            </template>
        </button>
        <b-form-checkbox v-model="sync_sheets" :value="true" :unchecked-value="false" plain inline>
            Sync SDS Changes to All Jobsites <i class="fa fa-question-circle" title="This will sync all SDS changes to jobsites currently associated with this catalog"></i>
        </b-form-checkbox>
    </template>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            loading: false,
            saving: false,
            catalog_id: this.$route.params.id,
            catalog: {},
            sync_sheets: false,
            errors: {},
            sheets: [],
            columns: [
                {key: 'id', label: 'Actions'},
                {key: 'data_sheet_name', label: 'SDS'},
                {key: 'manufacturer_name', label: 'Manufacturer'},
                {key: 'supplier_name', label: 'Supplier'}
            ],
        }
    },

    computed: {

    },

    methods: {
        getCatalog() {
            //Get the data
            this.$http
                .get('safety-data-sheets/catalogs/edit' + (this.catalog_id ? '/'+this.catalog_id : ''))
                .then(response => {
                    //Set all the data
                    this.catalog = response.data.catalog;
                    this.sheets = response.data.sheets;
                })
                .catch(response => {
                    //How to handle the error
                })
                .then(() => {
                    //Set loading
                    this.loading = true;
                });
        },

        saveCatalog() {
            //Saving
            this.saving = true;

            //Set the sheets
            this.catalog.sheets = this.sheets;
            this.catalog.sync_sheets = this.sync_sheets;

            //Send it
            this.$http
                .post('safety-data-sheets/catalogs/edit', this.catalog)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Catalog Saved');

                    //Push back to list page
                    this.$router.push('/safety-data-sheets/catalogs/view/'+response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if (error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
        },

        addSheet(sheet){
            //Check for Null
            if(sheet == null)
            {
                //Reset and Stop Here
                this.$refs.newSheetSelect.clearInput();

                //Stop
                return;
            }

            //Loop
            for(var i in this.sheets)
            {
                //Check type and id
                if(this.sheets[i].id == sheet.id)
                {
                    //Alert the user
                    this.$toastr.warning('This SDS is already in this catalog');

                    //Send it
                    this.$refs.newSheetSelect.clearInput();

                    //Stop
                    return;
                }
            }

            //Setters
            this.sheets.push(sheet);

            //Send it
            this.$refs.newSheetSelect.clearInput();

            //Without this, it won't re-render the input names
            //this.$forceUpdate();
        },

        removeSheet(data_sheet_id){
            //Loop and Build
            for (var i = this.sheets.length - 1; i >= 0; i--)
            {
                //Check the ID
                if(this.sheets[i].id == data_sheet_id)
                {
                    //Splice it out
                    this.sheets.splice(i, 1);

                    //Stop here
                    return;
                }
            }
        },
    },

    mounted() {
        //Get the injuries
        this.getCatalog();
    }
}
</script>
